<template>
  <Layout v-loading="isLoading">
    <template #top>
      <Head
        :searchConfig="tableData.searchConfig"
        @searchData="searchData"
        @addAuthorize="addAuthorize"
      />
    </template>
    <template>
      <Body
        :headConfig="tableData.headConfig"
        :tableData="data.content"
        @addUser="addUser"
        @unbind="unbind"
      />
    </template>
    <template #bottom>
      <Foot :total="data.total" @get-data="getPage" />
    </template>
  </Layout>
</template>

<script>
import getDataAuthorizationPage from "@/api/getDataAuthorizationPage.js";
import getUnbindUserPage from "@/api/getUnbindUserPage.js";
import addBindUser from "@/api/addBindUser.js";
import revokeAuthorization from "@/api/revokeAuthorization.js";
import addDataAuthorization from "@/api/addDataAuthorization.js";
import Layout from "@/components/Layout";
import Head from "@/components/Table/Head";
import Body from "@/components/Table/Body";
import Foot from "@/components/Table/Foot";
import requstData from "@/mixins/requstData.js";
import Transfer from "@/components/Transfer";
import eventBus from "@/utils/eventBus.js";

export default {
  mixins: [requstData({ content: [], total: 10 }, false)],
  components: {
    Layout,
    Head,
    Body,
    Foot,
  },
  created() {
    eventBus.$on("transfer-Change", this.transferChange);
    this.checkUrl(window.location.search);
  },
  destroyed() {
    eventBus.$off("transfer-Change", this.transferChange);
  },
  data() {
    return {
      tableData: {
        headConfig: {
          select: false,
          key: "pageId",
          list: [
            { label: "专页名称", prop: "pageName", width: "200" },
            { label: "专页ID", prop: "pageId", width: "200" },
            { label: "授权管理员", prop: "authorizationAdmin", width: "250" },
            { label: "授权日期", prop: "authorizationDate", width: "180" },
            { label: "已绑定用户", prop: "bindUserName" },
            {
              label: "操作",
              width: "220",
              operation: [
                {
                  type: 1,
                  label: "添加用户",
                  style: "primary",
                  listeners: "addUser",
                },
                {
                  type: 2,
                  label: "解除授权",
                  style: "danger",
                  listeners: "unbind",
                  confirm: "确定解除授权？",
                },
              ],
            },
          ],
        },
        searchConfig: {
          list: [
            {
              type: "input",
              model: "pageName",
              span: 4,
              placeholder: "请输入专业名称",
            },
            {
              type: "button",
              span: 5,
              operation: [
                {
                  type: 1,
                  label: "筛选",
                  style: "primary",
                  listeners: "searchData",
                },
                {
                  type: 2,
                  label: "+新增FaceBook授权",
                  style: "success",
                  listeners: "addAuthorize",
                },
              ],
            },
          ],
        },
      },
      select: [],
    };
  },
  methods: {
    async requst(params) {
      return await getDataAuthorizationPage(params);
    },
    transferChange(data) {
      this.select = data;
    },
    async addUser(data) {
      const h = this.$createElement;
      this.isLoading = true;
      let res = await getUnbindUserPage({ pageId: data.pageId });
      let list = res.userList.map((item) => {
        return {
          key: `${item.userId}_${item.userName}`,
          label: item.userName,
        };
      });
      this.isLoading = false;
      this.$confirm("", "添加用户", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        customClass: "messageTransfer",
        message: h(
          Transfer,
          { props: { data: list, titles: ["可选用户", "已选用户"] } },
          [],
        ),
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            if (this.select.length === 0) {
              this.$message({
                showClose: true,
                message: "请选择用户",
                type: "error",
              });
              return;
            }
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "提交中...";
            let select = this.select.map((item) => {
              let user = item.split("_");
              return {
                userId: user[0],
                userName: user[1],
                pageName: data.pageName,
                pageId: data.pageId,
              };
            });
            let res = await addBindUser(select);
            if (res === "ok") {
              eventBus.$emit("transfer-Reset");
              setTimeout(() => {
                done();
                this.getData();
              }, 200);
            }
            setTimeout(() => {
              instance.confirmButtonLoading = false;
            }, 300);
          } else {
            eventBus.$emit("transfer-Reset");
            setTimeout(() => {
              done();
            }, 200);
          }
        },
      })
        .then(() => {
          this.$message({
            showClose: true,
            type: "success",
            message: "添加成功!",
          });
        })
        .catch(() => {});
    },
    async unbind(data) {
      this.isLoading = true;
      let res = await revokeAuthorization({ pageId: data.pageId });
      this.isLoading = false;
      if (res === "ok") {
        this.$message({
          showClose: true,
          type: "success",
          message: "解除成功",
        });
        this.getData();
      }
    },
    addAuthorize(data) {
      const scope =
        "email,read_insights,pages_show_list,pages_read_engagement,pages_manage_posts,pages_manage_engagement,pages_read_user_content,business_management";
      top.location =
        window.location = `https://www.facebook.com/v24.0/dialog/oauth?scope=${scope}&client_id=154939337550104&redirect_uri=${
          process.env.NODE_ENV === "development"
            ? "https://localhost:8080"
            : "https://tools.nothingdb.com"
        }/home/authorize/page`;
    },
    async checkUrl(url) {
      let code = new URLSearchParams(url).get("code");
      if (code) {
        await addDataAuthorization({ code });
      }
      this.getData();
    },
  },
};
</script>

<style lang="less">
.messageTransfer {
  width: auto;
}
</style>
